import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class ProcessingStatus {

  private processing$: BehaviorSubject<boolean>;

  constructor() {
    this.processing$ = new BehaviorSubject(false);
  }

  setProcessingStatus(processing: boolean) {
    this.processing$.next(processing);
  }

  getProcessingStatus(): Observable<boolean> {
    return this.processing$.asObservable();
  }
}
